define([
  'jquery'
], function($) {
    $.fn.resizes = function(opt) {

        opt = $.extend({handle:"",cursor:"se-resize",body:"",min_width:200,min_height:100,onResized:null}, opt);

        if(opt.handle === "") {
            var $el = this;
        } else {
            var $el = this.find(opt.handle);
            var $body = this.find(opt.body);
        }

        return $el.css('cursor', opt.cursor).on("mousedown", function(e) {
            if(opt.handle === "") {
                var $resize = $(this);
            } else {
                var $resize = $(this).parent();
            }
            var z_idx = $resize.css('z-index'),
                rsz_h = $resize.outerHeight(),
                rsz_w = $resize.outerWidth(),
                pos_y = e.pageY,
                pos_x = e.pageX,
                bdy_w = $body.outerWidth(),
                bdy_h = $body.outerHeight();
            $resize.css('z-index', 10000001).parents().on("mousemove.jqueryResize", function(e) {
              var resized = false;
              if (rsz_w + e.pageX - pos_x >= opt.min_width) {
                resized = true;
                $resize.width(rsz_w + e.pageX - pos_x);
                //$body.width(bdy_w + e.pageX - pos_x);
              }
              if (rsz_h + e.pageY - pos_y >= opt.min_height) {
                resized = true;
                $resize.height(rsz_h + e.pageY - pos_y);
                $body.height(bdy_h + e.pageY - pos_y);
              }
              if (resized) {
                if (opt.onResized)
                  opt.onResized();
                else
                  $body.children().trigger('resize');
              }
            });
            $(document).on("mouseup", function() {
              $resize.parents().off('.jqueryResize');
            });
            e.preventDefault(); // disable selection
        });

    }
});
